import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import LinearProgress from "@mui/material/LinearProgress";
import { divProgressHide, divProgressShow } from "../../css/additional.js";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {v4 as uuidv4} from "uuid";
import {
  getCurrentOrg,
  getCurrentChild,
  getChildToParent,
  getAllChildren,
  getAllParents, api2ChildStoreParent, api2Parents, api2ParentsByOrganizationId
} from "../../utils/operations.js";

import { observer, inject } from "mobx-react";

import InputMask from 'react-input-mask';
import API from '../../utils/api';
import { toast } from 'react-toastify';
import {checkIfParentExistWithEmail} from "../../utils/apiUtils";
import {checkEmail} from "../../utils/misc";
import Checkbox from "@mui/material/Checkbox";
import {NavLink} from "react-router-dom";
import appRoutes from "../../utils/appRoutes";

class NewParent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        photo: "", // Файл
        photofile: "", // Картинка в аватаре
        firstname: "",
        lastname: "",
        organisation_id: "",
        email: "",
        phone: "",
        phone2: "",
        phone3: "",
        address: "",
        notify_on: true
      },
      emails: [],
      child_id: null,
      children_id: null,
      children: [],
      child: {},
      organisation: {},
      name: [],
      api_email: null,
      parent_id: null,
      opendialog: false, // Диалог с ошибками
      texterrors: "", // Список ошибок
      showProgress: true,
      existInAPI: false,
      sendInvitation: false,
    };
  }

  // Получение location для перехода на другие страницы
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    if (this.props.Auth.addParentToChildId)
      this.props.Auth.addParentToChildId = null;
  }

  loadData = () => {
    let orgId = this.props.Auth.orgId;
    let that = this;

    let data = this.state.data;
    data.organisation_id = orgId;
    this.setState({ data });

    if (this.props.Auth.addParentToChildId) {
      axios.all([
          API.get(getCurrentOrg + orgId),
          API.get(getCurrentChild + this.props.Auth.addParentToChildId),
          API.get(api2ParentsByOrganizationId(orgId))
      ]).then(
        axios.spread(function(organisation, childResult, parents) {
          let child = childResult.data;
          let gotOrg = organisation.data;

          const data = (parents.data.data || []).filter(Boolean);

          const name = data.map(p => ({
            textKey: p.firstname + " " + p.lastname + (p.email ? " — " + p.email : ""),
            valueKey: p.id
          }));

          that.setState({ name });

          that.setState({ organisation: gotOrg });
          that.setState({ child });
        })
      );
    } else {
      axios.all([
          API.get(getCurrentOrg + orgId),
          API.get(getAllChildren + "?filter=organisation_id%3D" + this.props.Auth.orgId.toString())
      ]).then(
        axios.spread(function(organisation, child) {
          let children = child.data.resource;
          let gotOrg = organisation.data;

          for (let i = 0; i < children.length; i++) {
            children[i].name = children[i].firstname + " " + children[i].lastname;
          }

          that.setState({ organisation: gotOrg });
          that.setState({ children });
        })
      );
    }

    this.setState({ showProgress: false });
  };

  saveData = async () => {
    let redirectUrl = "/children"
    let childId = this.props.Auth.addParentToChildId || this.props.Auth.child_id;
    let existInAPI = false;
    let email = this.state.data.email.length === 0 ? uuidv4() + "@none.com" : this.state.data.email;

    if (!checkEmail(email)) {
      return toast.error('Email must be valid!', { autoClose: 5000 })
    }

    existInAPI = await checkIfParentExistWithEmail(email);
    if (existInAPI) {
      return toast.error('Parent with this email is already existed. Please use another one!', { autoClose: 5000 })
    }

    this.setState({ showProgress: true });

    let stsData = {
      firstname: this.state.data.firstname,
      lastname: this.state.data.lastname,
      organisation_id: this.state.data.organisation_id,
      email: email,
      phone: this.state.data.phone,
      phone2: this.state.data.phone2,
      phone3: this.state.data.phone3,
      address: this.state.data.address,
      notify_on: this.state.data.notify_on,
      sendInvitation: this.state.sendInvitation,
    };

    try {
      if (this.props.Auth.addParentToChildId) {
        await API.post(api2ChildStoreParent(childId), stsData)
        redirectUrl = "/editchild/" + this.props.Auth.addParentToChildId
      } else {
        await API.post(api2Parents, stsData)
      }

      toast.success('New parent added successfully!');
      setTimeout(this.props.history.push(redirectUrl), 1000);
    } catch (error) {
      toast.error('Error while adding parent');
    }
  };

  // Открыть диалог
  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ opendialog: false });
  };

  handleOrgChange = (event, index, value) => {
    const data = this.state.data;
    data.organisation = value;
    this.setState({ data });
  };

  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  goPreviousPage = () => {
    this.props.history.goBack();
  };

  autoCompleteParent = value => {
    this.setState({ parent_id: value.valueKey });
  };

  addParent = async () => {
    const { parent_id } = this.state;
    const childId = this.props.Auth.addParentToChildId;

    if (!parent_id) return toast.error('Please select a parent first.');

    try {
      await API.post(api2ChildStoreParent(childId), { parent_id });
      this.props.history.push("/editchild/" + childId);
    } catch (error) {
      toast.error(error.response?.data?.error || 'Error linking parent');
    }
  };

  handleToggle = () => {
    let data = this.state.data;
    data.notify_on = !data.notify_on;

    this.setState({ data });
  };

  render() {
    return (
      <div style={{ maxWidth: 500, margin: "auto" }}>
        <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
          <div style={{ flex: 7 }}>&nbsp;</div>
          <div style={{ flex: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.data.notify_on}
                  onChange={this.handleToggle}
                />
              }
              label="Toggle notification"
              style={{ marginBottom: 16 }}
            />
          </div>
        </div>
        {this.props.Auth.addParentToChildId && (
          <div style={{ display: "inline-block" }}>
            <NavLink to={appRoutes.childEdit(this.props.Auth.addParentToChildId)} style={{ color: '#1e88e5' }}>
              {this.state.child.firstname + " " + this.state.child.lastname}
            </NavLink>
          </div>
        )}
        <br />
        {this.props.Auth.addParentToChildId && (
          <div>
            <br />
            <br />
            <span>Add an existing parent:</span>
            <Autocomplete
              options={this.state.name}
              getOptionLabel={(option) => option.textKey || ""}
              isOptionEqualToValue={(option, value) => option.valueKey === value.valueKey}
              fullWidth={true}
              autoComplete={false}
              onChange={(event, value) => value && this.autoCompleteParent(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Parent (Firstname Lastname)"
                  autoComplete="new-password"
                  inputProps={{ ...params.inputProps, autoCapitalize: 'none', autoCorrect: 'off', spellCheck: 'false', autoComplete: 'off' }}
                />
              )}
            />
            <br />
            <Button
              variant="text"
              color="primary"
              style={{ marginRight: 10 }}
              onClick={this.addParent}
            >
              Add Parent
            </Button>
          </div>
        )}
        <div
          style={this.state.showProgress ? divProgressShow : divProgressHide}
        >
          <LinearProgress />
        </div>
        <br />
        <br />
        {this.props.Auth.addParentToChildId && <span>Add new parent:</span>}
        <TextField
          id="firstname"
          label="First Name"
          error={this.state.data.firstname === ""}
          helperText={this.state.data.firstname === "" ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.firstname}
          onChange={this.handleChange}
          
        />
        <TextField
          id="lastname"
          label="Last Name"
          error={this.state.data.lastname === ""}
          helperText={this.state.data.lastname === "" ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.lastname}
          onChange={this.handleChange}
          margin="dense"
        />
        <TextField
          id="organisation"
          label="Organisation"
          fullWidth={true}
          value={this.state.organisation.name ?? ''}
          disabled={true}
          margin="dense"
        />
        <TextField
          id="email"
          label="Email"
          fullWidth={true}
          value={this.state.data.email}
          onChange={this.handleChange}
          margin="dense"
        />
        <InputMask
          mask="999-999-9999 ext. 999"
          fullWidth={true}
          value={this.state.data.phone}
          onChange={this.handleChange}
          id="phone"
          disabled={false}
        >
          {(inputProps) => <TextField {...inputProps} label="Phone 1" margin="dense" />}
        </InputMask>
        <InputMask
          mask="999-999-9999 ext. 999"
          fullWidth={true}
          value={this.state.data.phone2}
          onChange={this.handleChange}
          id="phone2"
          disabled={false}
        >
          {(inputProps) => <TextField {...inputProps} label="Phone 2" margin="dense" />}
        </InputMask>
        <InputMask
          mask="999-999-9999 ext. 999"
          fullWidth={true}
          value={this.state.data.phone3}
          onChange={this.handleChange}
          id="phone3"
          disabled={false}
        >
          {(inputProps) => <TextField {...inputProps} label="Phone 3" margin="dense" />}
        </InputMask>
        <TextField
          id="address"
          label="Address"
          fullWidth={true}
          value={this.state.data.address}
          onChange={this.handleChange}
          margin="dense"
        />
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={this.state.sendInvitation}
              onChange={() => this.setState({ sendInvitation: !this.state.sendInvitation})}
            />
          }
          label="Send payment invitation"
          style={{ marginTop: '20px' }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          <Button variant="contained" color="secondary" onClick={this.goPreviousPage}>Cancel</Button>
        </div>
        <Dialog
          open={this.state.opendialog}
          onClose={this.handleClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Form errors:</DialogTitle>
          <DialogContent>
            <div>
              {// Вывести список ошибок
                this.state.texterrors.split("\n").map((i, index) => {
                  return <div key={index}>{i}</div>;
                })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(NewParent))
